import React, { useState } from 'react';
import { Box, Card, Stack, Tab, Tabs, Typography } from '@mui/material';
import { dayList, timezones } from '../../../../../enums/enums';
import { useTranslation } from 'react-i18next';
import useEditBonusCashback from '../../../../../hooks/site/bonus/useEditBonusCashback';
import CashbackDay from './CashbackDay';
import CusCheckbox from '../../../../../components/material-ui/CusCheckbox';
import ShowContainer from '../../../../../components/material-ui/ShowContainer';
import CusTypographyBox from '../../../../../components/material-ui/CusTypographyBox';
import CusInput from '../../../../../components/material-ui/CusInput';
import SubgroupSave from '../../../../../components/bonus/ui/SubgroupSave';
import { ENUM_BONUS_ID } from '../../../../../enums/MenuItems';

export default function Cashback({ group, groupId }) {
  const { t } = useTranslation();
  const [activeDay, setActiveDay] = useState(0);

  const onTabChange = (_, newValue) => setActiveDay(newValue);

  const {
    cashbackEnable,
    cashbackTimeZone,
    packets,
    saveDisabled,
    lifetimeDays,
    useCasinoTax,
    lockSetting,
    updateSubgroups,
    selectCurrency,
    setSelectCurrency,
    changeSubgroup,
    changeLockSetting,
    changeCasinoTax,
    changeEnable,
    changeLifetimeDays,
    changePayoutDays,
    changeAutoActive,
    changeFieldPackage,
    changeHoldDay,
    onDeleteRow,
    onCopyToDays,
    onSave
  } = useEditBonusCashback(groupId);

  const timeZoneLabel = timezones.find((el) => el.value == cashbackTimeZone)?.label || '';

  return (
    <Stack display={'flex'} flexDirection={'column'} gap={1} py={1}>
      <Stack display={'flex'} flexDirection={'row'} gap={2} justifyContent={'space-between'}>
        <CusCheckbox title="Enable" checked={cashbackEnable} onChange={changeEnable} />
        <Stack display="flex" flexDirection="row" gap={2}>
          <ShowContainer condition={timeZoneLabel}>
            <Box>
              <CusTypographyBox
                title={'Time zone'}
                value={timeZoneLabel}
                toolTipTitle="To determine the day of the week taking into account the time zone."
                textAlign="center"
              />
            </Box>
          </ShowContainer>
        </Stack>
      </Stack>

      <Typography>
        {t(
          "The bonus replenishes the player's balance by a specified % of the deposit, at the moment his application for replenishment changes to the status 'Paid'. The bonus does not apply to the first deposit."
        )}
      </Typography>

      <Box>
        <Tabs value={activeDay} onChange={onTabChange} variant="scrollable" scrollButtons="auto">
          {dayList?.map((tab) => (
            <Tab
              key={tab.id}
              iconPosition="end"
              value={tab.id}
              style={{ fontWeight: 600 }}
              label={t(tab.title)}
            />
          ))}
        </Tabs>
        <Card variant="outlined">
          <CashbackDay
            activePackage={packets?.[activeDay] || {}}
            activeDay={activeDay}
            groupId={groupId}
            selectCurrency={selectCurrency}
            setSelectCurrency={setSelectCurrency}
            changeFieldPackage={changeFieldPackage}
            onDeleteRow={onDeleteRow}
            changeHoldDay={changeHoldDay}
            changePayoutDays={changePayoutDays}
            changeAutoActive={changeAutoActive}
            onCopyToDays={onCopyToDays}
          />
        </Card>
      </Box>

      <ShowContainer condition={packets?.length}>
        <Stack gap={0.5}>
          <CusCheckbox
            label="In bonus calculations, reduce the deposit amount by the amount of the commission withheld from the player for the deposit."
            checked={useCasinoTax}
            onChange={changeCasinoTax}
          />
          <CusInput
            label={'days, the lifetime of bonuses credited to the bonus balance.'}
            subLabel={'After which they will be deleted if they are not wagered.'}
            type="number"
            value={lifetimeDays ?? 0}
            onChange={(e) => changeLifetimeDays(+e.target.value)}
            inputProps={{ min: 0 }}
            isRowReverse
          />
        </Stack>
      </ShowContainer>

      <SubgroupSave
        lockSetting={lockSetting}
        updateSubgroups={updateSubgroups}
        saveDisabled={saveDisabled}
        id={ENUM_BONUS_ID.cashback}
        showLockSetting={true}
        isNodeGroup={!group?.game}
        showUpdate={!group?.game}
        onSave={onSave}
        changeSubgroup={changeSubgroup}
        changeLockSetting={changeLockSetting}
      />
    </Stack>
  );
}
